import CasTokenStrategy from '@/services/auth/tokenStrategies/casTokenStrategy';
import { bootstrap } from '@/services/auth/cas_service';

const BLOCKED_STATUS = 'Bloqueado';
const BLOCKED_ROUTE = '/blocked';
const AUTH_REDIRECT_STORAGE = 'AUTH_REDIRECT_STORAGE';

export const isCasUserBlocked = (casUser) => casUser?.profile?.status === BLOCKED_STATUS;

export const handleCasUser = async (casUser, onAllowed) => {
  if (isCasUserBlocked(casUser)) {
    new CasTokenStrategy().removeToken();
    sessionStorage.setItem(AUTH_REDIRECT_STORAGE, BLOCKED_ROUTE);
    await bootstrap.signoutSilent(casUser.id_token);
    return;
  }

  new CasTokenStrategy().setToken(casUser.id_token);
  onAllowed();
};
